import {InfiniteData} from '@tanstack/react-query';
import {IPaginatedResult} from '../../../../incase-domain/search';
import {IPresentation} from '../../../../incase-domain/presentation';
import {Option} from '../../../components/common/Select';
import {User} from '../../../../incase-domain/user';

const toPresentationOption = (item: Pick<IPresentation, '_id' | 'name'>): Option => ({
    label: item.name || '',
    value: item._id,
});

export const presentationOptions = (data: InfiniteData<IPaginatedResult<IPresentation>> | undefined): Option[] => {
    return data?.pages.flatMap((page) => page.content.map(toPresentationOption)) ?? [];
};

export const presentationOptionsWithSelected = (
    data: InfiniteData<IPaginatedResult<IPresentation>> | undefined,
    selected?: Pick<IPresentation, '_id' | 'name'>
): Option[] => {
    const options = presentationOptions(data);
    if (!selected?._id) {
        return options;
    }
    if (options.some((option) => option.value === selected._id)) {
        return options;
    }
    return [toPresentationOption(selected), ...options];
};

const toPresenterOption = (item: User): Option => ({
    label: `${item.username} - ${item.email}`,
    value: item._id,
});

export const presenterOptions = (data: InfiniteData<IPaginatedResult<User>> | undefined): Option[] => {
    return data?.pages.flatMap((page) => page.content.map(toPresenterOption)) ?? [];
};
